/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_f271b5c2',
  resizeIsShort: 'resizeIsShort_f271b5c2',
  buttonGroup: 'buttonGroup_f271b5c2',
  settingsGroup: 'settingsGroup_f271b5c2',
  itemCountDropdown: 'itemCountDropdown_f271b5c2',
};

export = styles;

loadStyles([{"rawString":".root_f271b5c2{display:block}.resizeIsShort_f271b5c2{width:400px}.buttonGroup_f271b5c2{margin-bottom:40px}.buttonGroup_f271b5c2 button{margin-right:20px}.settingsGroup_f271b5c2{padding-top:20px}.itemCountDropdown_f271b5c2{width:180px}"}]);
/* tslint:enable */